import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/Reveal";

export default function Libro() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/site/info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info) return <div className="min-h-screen bg-cream" />;

  return (
    <div className="bg-cream grain pt-32 pb-24">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-3">
            <p className="text-xs uppercase tracking-[0.3em] text-peach">— Bonus</p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <Reveal>
              <h1 className="font-heading text-6xl md:text-[8rem] leading-[0.85] tracking-tighter">
                Il mio<br />
                <span className="italic text-peach">quaderno.</span>
              </h1>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 mt-24 border-t border-line pt-16">
        <div className="grid grid-cols-12 gap-6 md:gap-16 items-start">
          <Reveal className="col-span-12 md:col-span-5">
            <div
              className="overflow-hidden"
              style={{
                width: "100%",
                borderRadius: "8px",
                boxShadow:
                  "0 12px 32px -10px rgba(26,25,24,0.22), 0 4px 12px -6px rgba(26,25,24,0.12)",
              }}
            >
              <img
                src="https://customer-assets.emergentagent.com/job_visual-engine-20/artifacts/2y8xtcbt_copertina%20libro%20giovanni%20gabban.jpg"
                alt="Come fare il piano social aziendale — Giovanni Gabban, I Quaderni di Liquid Diamond"
                loading="lazy"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "480px",
                  display: "block",
                  objectFit: "contain",
                }}
              />
            </div>
          </Reveal>

          <div className="col-span-12 md:col-span-7 space-y-8">
            <Reveal>
              <h2 className="font-heading text-4xl md:text-5xl tracking-tight leading-tight">
                {info.book.title}
              </h2>
              <p className="text-peach text-xs uppercase tracking-[0.22em] mt-2">{info.book.subtitle}</p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="text-lg text-ink/80 leading-relaxed">{info.book.description}</p>
            </Reveal>
            <Reveal delay={0.25}>
              <ul className="space-y-3 text-ink/80 border-t border-line pt-6">
                {[
                  "Guida pratica e operativa, non teorica",
                  "Pensata per founder, marketing manager e consulenti",
                  "Due casi studio reali, completamente smontati",
                  "Approccio generativo: domande prima delle risposte",
                ].map((b) => (
                  <li key={b} className="flex gap-4">
                    <span className="text-peach mt-1.5">●</span>
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.35}>
              <div className="flex flex-wrap gap-4 items-center">
                <a
                  href={info.book.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-3 bg-ink text-cream rounded-full px-8 py-5 text-xs uppercase tracking-[0.22em] hover:bg-peach transition-colors"
                  data-testid="book-cta"
                >
                  {info.book.cta} <ArrowUpRight size={16} />
                </a>
                <a
                  href="https://www.youtube.com/watch?v=J6Wm48MGzl8&t=292s"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="book-feltrinelli-cta"
                  className="inline-flex items-center gap-3 bg-peach text-cream rounded-full px-8 py-5 text-xs uppercase tracking-[0.22em] hover:bg-peach-hover transition-colors"
                >
                  ▶ Guarda la presentazione in Feltrinelli
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
